import { type Epic, combineEpics } from 'redux-observable';
import { filter, mergeMap } from 'rxjs';
import { request } from '@/core';
import { fetchEventRequest } from '@/api/events';
import {
  fetchEvent,
  setCurrentEvent,
  startRealtimeIncidents,
} from '../actions';

const fetchEventEpic: Epic = (action$) =>
  action$.pipe(
    filter(fetchEvent.match),
    request(({ payload }) => fetchEventRequest(payload), fetchEvent),
  );

const fetchEventSucceededEpic: Epic = (action$) =>
  action$.pipe(
    filter(fetchEvent.succeeded.match),
    mergeMap(
      ({
        payload: {
          data: { event, incidents, contributors },
        },
      }) => [
        setCurrentEvent({ event, incidents, contributors }),
        startRealtimeIncidents({ eventId: event.id }),
      ],
    ),
  );

export default combineEpics(fetchEventEpic, fetchEventSucceededEpic);
